export const runCode = (code) => {
  return {
    type: 'RUN',
    payload: {code}
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js